// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@west/App/Components/Notify";
import { onePageCheckoutDeliveryMethodStyles } from "@west/Overrides/Widgets/OnePageCheckout/OnePageCheckoutDeliveryMethod";
import { css } from "styled-components";

onePageCheckoutDeliveryMethodStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};

onePageCheckoutDeliveryMethodStyles.titleGridItem = {
    css: css`
        display: flex;
        align-items: center;
        &:not(:has(+ div)) {
            display: none;
        }
    `,
};

onePageCheckoutDeliveryMethodStyles.titleText = {
    variant: "h3",
    css: css`
        display: flex;
        align-items: center;
        margin-bottom: 0;
    `,
};

onePageCheckoutDeliveryMethodStyles.shippingOptionsTooltip = {
    cssOverrides: {
        tooltipWrapper: css`
            margin-left: 7px;
        `,
    },
};

onePageCheckoutDeliveryMethodStyles.shippingOptionsIcon = {
    size: 20,
    color: "common.ui8",
};

onePageCheckoutDeliveryMethodStyles.servicesGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        gap: 20px;
    `,
};

onePageCheckoutDeliveryMethodStyles.deliveryDateGridItem = {
    width: 12,
    css: css`
        & > div > div {
            width: 100%;
        }
    `,
};

onePageCheckoutDeliveryMethodStyles.notifyMessage = {
    css: css`
        margin-top: 12px;
    `,
};
